<script>
    import { Row, Col, Card, CardBody } from 'sveltestrap'
    import { InputText, Select, InputCheckbox } from '@fno/component2/form.js'
    import { icons, urlPrefix } from 'fanx-schema/value/arenaIcons'
    import { get } from 'dot-prop'

    export let context
    export let formKey
    export let index
    export let rewardsEnabled
    export let tier

    const arenaIconList = icons
        .map(({ name, filename }) => ({
            name,
            id: urlPrefix + filename
        }));

    let hasIssue

    $: {
        const alerts = get(context, 'alerts') || []
        const errors = get(context, `errors.${formKey}.${index}`)

        hasIssue =
            (get(context, 'alerts') || []).find(alert => Number(alert.index) == index) ||
            errors
            ? true
            : false

        if (hasIssue) { console.log({ alerts, errors }); }
    }
</script>

<style>
    .arenaIcon {
        height: 50px;
        margin-top: 15px;
        filter: grayscale(1) invert(1);
    }

    :global(.venue-info-error) {
        border: 1px solid red;
    }
</style>

<Card>
    <CardBody class="{hasIssue ? 'venue-info-error' : ''}">
        <Row class="mb-3">
            <Col xs="12" md="6" lg="6" xl="6">
                <InputText
                    label="Venue Name"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.name"
                    bind:value={context.form[formKey][index].attributes.name}
                    on:change
                />
            </Col>
            <Col xs="10" md="4" lg="4" xl="4">
                <Select
                    required
                    label="Venue Icon"
                    {context}
                    {index}
                    includeDefaultValue
                    options={arenaIconList}
                    {formKey}
                    keypath="attributes.arenaIcon.url"
                    bind:value={context.form[formKey][index].attributes.arenaIcon.url}
                    on:change
                />
            </Col>
            <Col xs="2" md="2" lg="2" xl="2">
                {#if context.form[formKey][index].attributes.arenaIcon.url}
                    <img
                        class="arenaIcon"
                        src={context.form[formKey][index].attributes.arenaIcon.url}
                        alt="Selected arena icon"
                    />
                {/if}
            </Col>
        </Row>
        <Row class="mb-3">
            <Col>
                <InputText
                    label="Venue Location - Latitude"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.latitude"
                    bind:value={context.form[formKey][index].attributes.latitude}
                    on:change
                />
            </Col>
            <Col>
                <InputText
                    label="Venue Location - Longitude"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.longitude"
                    bind:value={context.form[formKey][index].attributes.longitude}
                    on:change
                />
            </Col>
        </Row>

    {#if tier === 'tier3' }
        <Row class="mb-3">
            <Col>
                <InputText
                    label="Geofence Radius (meters)"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.geofenceRadius"
                    bind:value={context.form[formKey][index].attributes.geofenceRadius}
                    on:change
                />
            </Col>
            <Col class='d-flex flex-direction-column align-items-center'>
                {#if rewardsEnabled}
                    <InputCheckbox
                        label="Rewardable?"
                        {context}
                        {formKey}
                        {index}
                        keypath="attributes.$isRewardable"
                        bind:value={context.form[formKey][index].attributes.$isRewardable}
                        on:change
                    />
                {/if}
            </Col>
        </Row>
    {/if}
    </CardBody>
</Card>
